// Debug helper for auth issues
export const debugAuth = () => {
  console.log('🔍 DEBUG AUTH:');
  
  // Check localStorage
  const localStorageKeys = Object.keys(localStorage);
  console.log('📦 localStorage keys:', localStorageKeys);
  
  // Check sessionStorage
  const sessionStorageKeys = Object.keys(sessionStorage);
  console.log('📦 sessionStorage keys:', sessionStorageKeys);
  
  // Check plexiSession
  const plexiSessionLocal = localStorage.getItem('plexiSession');
  const plexiSessionSession = sessionStorage.getItem('plexiSession');
  
  console.log('🔑 plexiSession in localStorage:', plexiSessionLocal ? 'EXISTS' : 'NOT FOUND');
  console.log('🔑 plexiSession in sessionStorage:', plexiSessionSession ? 'EXISTS' : 'NOT FOUND');
  
  // Try to decrypt
  if (plexiSessionLocal || plexiSessionSession) {
    try {
      const data = plexiSessionLocal || plexiSessionSession;
      const decrypted = decodeURIComponent(atob(data));
      const parsed = JSON.parse(decrypted);
      console.log('✅ Session data:', {
        hasUser: !!parsed.user,
        hasToken: !!parsed.session?.token,
        userEmail: parsed.user?.email,
        expiresAt: parsed.session?.expires_at
      });
    } catch (e) {
      console.error('❌ Failed to decrypt session:', e);
    }
  }
  
  // Check AuthService
  import('../services/authService').then(({ AuthService }) => {
    const session = AuthService.getSession();
    const token = AuthService.getToken();
    const user = AuthService.getCurrentUser();
    
    console.log('🔐 AuthService.getSession():', session ? 'EXISTS' : 'NULL');
    console.log('🎫 AuthService.getToken():', token ? `EXISTS (${token.substring(0, 20)}...)` : 'NULL');
    console.log('👤 AuthService.getCurrentUser():', user ? user.email : 'NULL');
  });
};

// Add to window for easy debugging
if (typeof window !== 'undefined') {
  (window as any).debugAuth = debugAuth;
}
